import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { useMsal } from "@azure/msal-react";

export default function Logout() {
  const [open, setOpen] = React.useState(false);
  const { instance } = useMsal();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const logout = async () => {
    await instance.logoutRedirect({
      postLogoutRedirectUri: "/", // Redirect here after logout
    });  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div style={{cursor:"pointer"}} onClick={handleClickOpen}>
      <PowerSettingsNewIcon/>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Logout"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure want to exit from the tool ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={logout}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}